import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { NewBookingDetailsPage } from '../../../../../features/parking/ui/booking-pages/new-booking/NewBookingDetails';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default NewBookingDetailsPage;
